import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  imageContainer: {
    alignItems: 'center',
    backgroundColor: theme.palette.blue.lightest,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    height: '95%',
    marginTop: theme.spacing(1),
    maxHeight: '230px',
    maxWidth: '290px',
    position: 'relative',
  },
  input: {
    display: 'none',
    width: '40%',
  },
  inputLabelContainer: {
    position: 'absolute',
    top: 0,
    left: theme.spacing(1),
    display:'flex',
    alignItems:'flex-end',
  },
  inputButton: {
    marginTop: theme.spacing(1),
  },
  inputLabel: {
    padding: theme.spacing(1),
    fontSize:16,
    fontWeight:300,
    lineHeight:'18.75px',
  },
  img: {
    borderRadius: '8px',
    maxHeight: '100%',
    padding: theme.spacing(0.5),
    width: '100%',
  },
  hashtag: {
    maxWidth: '230px',
  },
  buttonContainer: {
    marginTop: theme.spacing(4),
  },
}));
